<template>
    <el-container class="container">
        <el-aside class="home_aside show" v-if="!store.state.isMobile">
            <Aside @asideCose="asideCose"/>
        </el-aside>
        <el-container style="width:100%;">
            <!-- 头部 -->
            <el-header class="home_header"  v-if="!store.state.isMobile">
                <Header  />
            </el-header>
            <!-- 主体 -->
            <el-main class="home_main">
                <Main />
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import Header from '../components/HeaderComponent.vue'
import Main from '../components/MainComponent.vue'
import Aside from '../components/AsideComponent.vue'
import { useStore } from 'vuex';
export default {
    components: { Header, Main, Aside },
    setup() {
        const store = useStore();
        //监视属性
        return { store}
    },
    data() {
        return {
        }
    },
    methods: {
        asideCose(){
        }
    },
    created() {
        document.documentElement.setAttribute('theme', 'light')
    },
}
</script>
<style  >
@import '../assets/css/main.css';
</style>
<style scoped lang="scss">
.home_header {
    height: 52px;
    width: 100%;
    background-color: #409EFF;
    display: flex;
}

.home_aside {
    width: 250px;
    background-color: #FFFFFF;
    overflow-x: hidden;
    height: 100%;
}

.home_main {
   
    width: 100%;
    height: 100%;
    overflow-x: visible;
}

.container {
    height: 100%;
    width: 100%;
    background-color: var(--bgColor);
    
}
</style>